import React, { useState } from "react";
import { Markdown } from "@design-system/Markdown/Markdown";
import { VStack } from "@design-system/VStack/VStack";
import { RangeControl, TextareaControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./TextFormattingPlayground.module.scss";

const DEFAULT_MARKDOWN = `# Monthly close summary

The books for **Northwind Consulting** are ready for review.

## What changed

- Reconciled the operating account
- Matched three outstanding receipts
- Flagged one transaction for follow-up

Read the [close checklist](https://kick.co) or run \`npm run typecheck\`.

\`\`\`
Status: Ready for review
Variance: $0.00
\`\`\`
`;

export const MarkdownPlayground = () => {
    const [markdown, setMarkdown] = useState(DEFAULT_MARKDOWN);
    const [containerWidth, setContainerWidth] = useState(640);

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Markdown</h2>
                    <VStack gap={12}>
                        <TextareaControl
                            label="Source"
                            value={markdown}
                            rows={10}
                            onChange={setMarkdown}
                        />
                        <RangeControl
                            label={`Container width: ${containerWidth}px`}
                            value={containerWidth}
                            min={280}
                            max={840}
                            step={20}
                            onChange={setContainerWidth}
                        />
                    </VStack>
                </section>
            }
        >
            <ShowcasePreview
                summary={`${containerWidth}px container`}
                width="full"
                output={JSON.stringify(
                    {
                        props: {
                            children: markdown,
                            options: { forceBlock: true },
                        },
                        showcaseState: { containerWidth },
                    },
                    null,
                    2,
                )}
            >
                <div
                    className={styles.markdownContainer}
                    style={{ width: containerWidth }}
                >
                    <Markdown
                        className={styles.markdownSurface}
                        options={{ forceBlock: true }}
                    >
                        {markdown}
                    </Markdown>
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
